import { autorun } from "mobx";
import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useEffect } from "preact/hooks";
import CreatorHeader from "./CreatorHeader";
import CreatorBody from "./CreatorBody";
import CreatorFooter from "./CreatorFooter";
import { Tracking } from "restaumatic-client";
function Creator(props) {
    const { productCard } = props;
    const { creator } = productCard;
    useEffect(() => {
        Tracking.trackEvent({
            tag: "VisitPage",
            contents: { page: "ProductCard" },
        });
        autorun(() => productCard.creator.fixAvailability()), [productCard];
    });
    return (h(Fragment, null,
        h(CreatorHeader, { photoUrn: creator.product.photo }),
        h(CreatorBody, { creator: creator }),
        h(CreatorFooter, { price: creator.price, isSubmitVisible: creator.isSubmitVisible, isCancelVisible: creator.isCancelVisible, onSubmit: () => productCard.finish() })));
}
export default observer(Creator);
